import * as React from "react";
import { OutlinedInput } from "../../Input";
import ModalBase from "../ModalBase";
import { CheckMarkCircle, CrossIcon } from "../../icons";
import "./index.css";
import Button from "../../Button";

const ForgotPassModal = ({ isOpen, setIsOpen, goToSignIn }) => {
  const [mail, setMail] = React.useState("");
  const [page, setPage] = React.useState(0);

  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  return (
    <ModalBase
      title={"Forgot password"}
      isOpen={isOpen}
      width={"729px"}
      setIsOpen={setIsOpen}
    >
      <div
        className="forgot-pass-section"
        style={{
          transform: page === 0 ? "translateX(50%)" : "translateX(-100%)",
        }}
      >
        <div className="forgot-pass container">
          <span className="text-medium forgot-pass-header">
            Forgot Password
          </span>
          <OutlinedInput
            name={"mail"}
            onChange={(e) => setMail(e.target.value)}
            value={mail}
            title={"Email"}
            gap={"16px"}
            type={"email"}
          />
          <div
            className={"forgot-pass-conf-btn"}
            onClick={() => {
              setPage(1);
            }}
            style={{
              backgroundColor: "var(--lightGrey)",
              fontWeight: "bold",
              color: "var(--red)",
            }}
          >
            Reset Password
          </div>
          <span>
            Have an account?&nbsp;
            <strong onClick={goToSignIn}>Sign in</strong>
          </span>
        </div>
      </div>
      <div
        className="forgot-pass-section mail"
        style={{
          transform: page === 1 ? "translateX(-50%)" : "translateX(100%)",
        }}
      >
        <div onClick={() => setPage(0)} className="forgot-pass container">
          <CrossIcon
            size={20}
            onClick={() => setIsOpen(false)}
            className={"mail-sent-cross-icon"}
          />
          <CheckMarkCircle size={80} className={"mail-sent-icon"} />
          <div className="mail-sent-header">Reset password email sent</div>
          <span className="sent-success-description">
            You should soon receive an email allowing you to reset your
            password. Please make sure to check your spam and trash if you can’t
            find the email.
          </span>
        </div>
      </div>
    </ModalBase>
  );
};

export default ForgotPassModal;
